import {Component, OnInit, OnDestroy} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {TaxFormsService} from '../../../services/tax-forms.service';
import {TaxFormSupportiveLanguage} from '../../../models/tax-forms.model';
import {SnackBarService} from '@core/services/snack-bar.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {takeUntil} from 'rxjs/operators';
import {combineLatest, Subject} from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import {TranslationService} from "../../../../translation/services/translation.service";
import {StorageSettings} from "../../../../translation/models/translation.constants";
import { DialogModel } from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-form-grid-compare-dialog',
  templateUrl: './form-grid-compare-dialog.component.html',
  styleUrls: ['./form-grid-compare-dialog.component.scss'],
})
export class FormGridCompareDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  fileToUpload: File;
  isFileScanned: boolean;
  taxformsSupportiveLanguage: TaxFormSupportiveLanguage[] = [];
  isCheckFileFormat: boolean = true;
  toLanguage: string;
  currentTaxForm: any;
  selectedRadioOption: string;
  bringNewDataIntoTranslatedForm: boolean = false;
  canBringNewData: boolean = false;
  fileIdByUploading: string = null;
  unsubscribe$ = new Subject<void>();
  translationId: string;
  storageSettings: string = 'Stored';
  storageOptions = StorageSettings;

  constructor(private taxFormsService: TaxFormsService,
              private snackBarService: SnackBarService,
              private translationService: TranslationService,
              private fuseSplashScreenService: FuseSplashScreenService,
              public dialogRef: MatDialogRef<FormGridCompareDialogComponent>) {
    this.isFileScanned = false;
    this.toLanguage = null;
    this.currentTaxForm = null;
    this.selectedRadioOption = null;
    this.bringNewDataIntoTranslatedForm = false;
  }

  ngOnInit() {
    this.translationId = this.data.input.translationId;
    this.taxformsSupportiveLanguage = this.data.input.taxformsSupportiveLanguage;
    this.currentTaxForm = this.data.input.currentTaxForm;
    console.log('in compare forms dialog:', this.currentTaxForm);
    this.initialSetUp();
  }

  handleFileInput() {
    const expectedType: any[] = ['.pdf']; // TODO: added more file type
    const fileFormatOutput = this.taxFormsService.handleFileInput(
      this.fileToUpload,
      expectedType
    );
    if (fileFormatOutput) {
      this.isCheckFileFormat = true;
    } else {
      this.isCheckFileFormat = false;
      this.fileToUpload = null;
    }
  }

  onOkClicked(): boolean {
    if (this.selectedRadioOption === 'UserFormOne') {
      if (!this.fileToUpload) {
        this.snackBarService.showError('Please select a file.');
        return false;
      }

      if (this.isFileScanned && !this.toLanguage) {
        this.snackBarService.showError('Please select a language.');
        return false;
      }
      if (this.taxFormsService.isOcrNotSupportiveLanguageSelected(this.toLanguage) && this.isFileScanned) {
        this.snackBarService.showError('The language in the scanned document you are uploading is not supported by our OCR engine.\n' +
          'Please upload an electronic version of the document.');
        return false;
      }
      let action = 'compare';
      if (this.currentTaxForm.pairedForm && this.canBringNewData && this.bringNewDataIntoTranslatedForm) {
        action = 'bringNewData';
      }
      this.data.input.formConfig = {
        selectedFormType: 'UserFormOne',
        action: action,
        isFileScanned: this.isFileScanned,
        toLanguage: this.toLanguage,
        fileName: this.fileToUpload.name,
        storageSettings: this.storageSettings
      };
      if (this.fileToUpload) {
        this.UpoloadUserForm(action);
      }
    } else {
      this.data.input.formConfig = {
        selectedFormType: 'EnglishTranslated',
        action: 'compare',
        leftFormId: this.currentTaxForm.id,
        rightFormId: this.currentTaxForm.pairedForm.id,
        storageSettings: this.storageSettings
      };
      this.uploadSystemForm(this.currentTaxForm.id, this.currentTaxForm.pairedForm.id);
    }
    return false;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private initialSetUp() {
    if (this.currentTaxForm) {
      if (this.currentTaxForm.pairedForm) {
        this.selectedRadioOption = 'EnglishTranslated';
      } else {
        this.selectedRadioOption = 'UserFormOne';
      }
      this.setCanBringNewData();
    }
  }

  setCanBringNewData() {
    this.canBringNewData = Boolean((this.selectedRadioOption === 'UserFormOne') && (this.currentTaxForm.pairedForm && this.currentTaxForm.pairedForm.id));
  }

  onSelectionChange($event: any) {
    this.setCanBringNewData();
  }

  fileUploader() {
  }

  private uploadSystemForm(formId1, formId2) {
    this.fuseSplashScreenService.show();
    const combinedData$ = combineLatest([this.taxFormsService.getConvertedTaxformsId(formId1, this.translationId).pipe(takeUntil(this.unsubscribe$)),
      this.taxFormsService.getConvertedTaxformsId(formId2, this.translationId).pipe(takeUntil(this.unsubscribe$))]);
    let hasData = false;
    combinedData$.subscribe((result: any[]) => {
      if (!hasData && result && result[0] && result[1]) {
        hasData = true;
        this.fuseSplashScreenService.hide();
        console.log('formconfig;', result);
        this.data.input.formConfig.fileId1 = result[0];
        this.data.input.formConfig.fileId2 = result[1];
        this.dialogRef.close({action: 'ok', data: this.data});
      }
    });
  }

  private UpoloadUserForm(action) {
    this.fuseSplashScreenService.show();
    const combinedData$ = combineLatest([this.taxFormsService.getConvertedTaxformsId(this.currentTaxForm.id, this.translationId).pipe(takeUntil(this.unsubscribe$)),
      this.translationService.uploadClientFile(this.fileToUpload, this.translationId).pipe(takeUntil(this.unsubscribe$))]);
    let hasData = false;
    combinedData$.subscribe((result: any[]) => {
      if (!hasData && result && result[0] && result[1]) {
        hasData = true;
        this.fuseSplashScreenService.hide();
        console.log('formconfig;', result);
        this.data.input.formConfig.fileId1 = result[0];
        this.data.input.formConfig.fileId2 = result[1];
        this.dialogRef.close({action: 'ok', data: this.data});
      }
    });
  }
}
